import React, { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import InputBox from "./InputBox"
import { CurrencyTypeSelect, CurrencyTypeSelectBudget } from "@components/SearchResults/SearchFilters/filterElements"
import { getUser, isAuthenticated } from "@starberry/myaccount-website-utils"
const TextInput = ({ type, name, value, placeholder, label, defaultValue, ...props }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const [login, setlogin] = useState(false)
  useEffect(() => {
    setlogin(isAuthenticated())
  },[isAuthenticated])
  const userData = getUser();
  let data = userData?.email && name === "email" ? userData?.email : userData?.name && name === "name" ? userData?.name : defaultValue ? defaultValue : value
  return (
    <InputBox name={name} label={label} errors={errors}>
      {name === "budget" ?
      <div className="d-flex align-items-center budget">
      <input
        id={name}
        type={type || "text"}
        className="input-field"
        placeholder={placeholder}
        defaultValue={data}
        {...props}
        {...register(name, { valueAsNumber: type === "number" })}
      />
     
      <CurrencyTypeSelectBudget />
      </div> :<input
        id={name}
        type={type || "text"}
        className="input-field"
        placeholder={placeholder}
        defaultValue={data}
        {...props}
        {...register(name, { valueAsNumber: type === "number" })}
      />
}
    </InputBox>
  )
}

export default TextInput
